module.exports = __webpack_public_path__ + "static/media/player_body.e1d04a56.png";